import { Theme, createStyles } from '@material-ui/core';
import { orange } from '@material-ui/core/colors';
import { StyleRules } from '@material-ui/core/styles/withStyles';
import { white } from '../../../../theme/palette';

const styles = (theme: Theme): StyleRules<string, {}> => createStyles({
  root: {
    width: 960,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  flexOne: {
    flexGrow: 1,
    minWidth: 40,
  },
  details: {
    padding: theme.spacing(2),
  },
  boxInGrid: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  dateGroup: {
    flexGrow: 2,
    margin: `auto ${theme.spacing(2)}px`,
    '& .MuiButton-root': {
      borderRadius: 0,
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(2),
      marginRight: 0,
    },
  },
  datePicker: {
    width: 140,
  },
  statusProcessButton: {
    color: white,
    backgroundColor: orange[700],
  },
  des: {
    display: 'flex',
    marginTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    justifyContent: 'space-between',
  },
});

export default styles;
